import React, { useEffect, useState } from "react";
import { SESSION_TIMEOUT } from "./constants";
import CustomModal from "components/custom-modal/CustomModal";
import Button from "components/button/Button";
import "./session-timeout-warning.css";

interface Props {
  open: boolean;
  onStay: () => void;
  onSignOut: () => void;
}

function ClockIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  );
}

export function SessionTimeoutWarning({ open, onStay, onSignOut }: Props) {
  const [secondsLeft, setSecondsLeft] = useState(SESSION_TIMEOUT.COUNTDOWN_SEC);

  useEffect(() => {
    if (!open) {
      setSecondsLeft(SESSION_TIMEOUT.COUNTDOWN_SEC);
      return;
    }
    const interval = setInterval(() => {
      setSecondsLeft((s) => {
        if (s <= 1) {
          clearInterval(interval);
          return 0;
        }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [open]);

  const mins = Math.floor(secondsLeft / 60);
  const secs = secondsLeft % 60;
  const timeStr = `${mins}:${secs.toString().padStart(2, "0")}`;

  return (
    <CustomModal isOpen={open}>
      <div className="v1-timeout-modal">
        <div className="v1-timeout-icon">
          <ClockIcon />
        </div>

        <h3 className="v1-timeout-title">Session Timeout</h3>

        <p className="v1-timeout-msg">
          You've been inactive. You'll be signed out automatically.
        </p>

        <span className="v1-timeout-countdown">{timeStr}</span>

        <div className="v1-timeout-actions">
          <Button variant="primary" onClick={onStay}>
            Stay signed in
          </Button>
          <Button variant="ghost" onClick={onSignOut}>
            Sign out now
          </Button>
        </div>
      </div>
    </CustomModal>
  );
}
